module.exports = __webpack_public_path__ + "fonts/iconfont.0ee729e4.eot";